var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"none"}}),_vm._v(" "),_c('path',{attrs:{"d":"M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21924328","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/iconAlignTop.vue
// module id = null
// module chunks = 